var map = {
	"@ehs/corrective-action/detail/corrective-action.module": [
		"./src/app/ehs/corrective-action/detail/corrective-action.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-emergency-drill-action-drill-actio~06abf6ec",
		"default~app-ehs-risk-risk-module~ehs-corrective-action-detail-corrective-action-module~ehs-risk-cond~90c16981",
		"common",
		"ehs-corrective-action-detail-corrective-action-module"
	],
	"@ehs/corrective-action/list/corrective-action-record.module": [
		"./src/app/ehs/corrective-action/list/corrective-action-record.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-corrective-action-list-corrective-action-record-module"
	],
	"@ehs/dashboard/emergency/emergency-dashboard.module": [
		"./src/app/ehs/dashboard/emergency/emergency-dashboard.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~ee4ecec2",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~24725816",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~d71f92ed",
		"default~app-ehs-dashboard-dashboard-module~ehs-dashboard-emergency-emergency-dashboard-module",
		"common",
		"ehs-dashboard-emergency-emergency-dashboard-module"
	],
	"@ehs/dashboard/hazard/hazard-dashboard.module": [
		"./src/app/ehs/dashboard/hazard/hazard-dashboard.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~ee4ecec2",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~24725816",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~d71f92ed",
		"default~app-ehs-dashboard-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-module",
		"common",
		"ehs-dashboard-hazard-hazard-dashboard-module"
	],
	"@ehs/dashboard/issue/issue-dashboard.module": [
		"./src/app/ehs/dashboard/issue/issue-dashboard.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~ee4ecec2",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~24725816",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~d71f92ed",
		"common",
		"ehs-dashboard-issue-issue-dashboard-module"
	],
	"@ehs/dashboard/overview/overview-dashboard.module": [
		"./src/app/ehs/dashboard/overview/overview-dashboard.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~ee4ecec2",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~24725816",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-dashboard-overview-overview-dashboard-modul~cac639de",
		"default~app-ehs-dashboard-dashboard-module~ehs-dashboard-overview-overview-dashboard-module",
		"common",
		"ehs-dashboard-overview-overview-dashboard-module"
	],
	"@ehs/dashboard/regulation/regulation-dashboard.module": [
		"./src/app/ehs/dashboard/regulation/regulation-dashboard.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~ee4ecec2",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~d71f92ed",
		"common",
		"ehs-dashboard-regulation-regulation-dashboard-module"
	],
	"@ehs/dashboard/risk-assessment/risk-assessment-dashboard.module": [
		"./src/app/ehs/dashboard/risk-assessment/risk-assessment-dashboard.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~ee4ecec2",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~24725816",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~d71f92ed",
		"default~app-ehs-dashboard-dashboard-module~ehs-dashboard-risk-assessment-risk-assessment-dashboard-m~7757e66a",
		"common",
		"ehs-dashboard-risk-assessment-risk-assessment-dashboard-module"
	],
	"@ehs/dashboard/training/training-dashboard.module": [
		"./src/app/ehs/dashboard/training/training-dashboard.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~ee4ecec2",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~24725816",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~d71f92ed",
		"default~app-ehs-dashboard-dashboard-module~ehs-dashboard-training-training-dashboard-module",
		"default~ehs-dashboard-training-training-dashboard-module~ehs-training-class-class-module",
		"common",
		"ehs-dashboard-training-training-dashboard-module"
	],
	"@ehs/documentation/doc-classification/doc-classification.module": [
		"./src/app/ehs/documentation/doc-classification/doc-classification.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-documentation-doc-classification-doc-classification-module"
	],
	"@ehs/documentation/doc-list/doc-list.module": [
		"./src/app/ehs/documentation/doc-list/doc-list.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-documentation-doc-list-doc-list-module"
	],
	"@ehs/documentation/doc-management/doc-management.module": [
		"./src/app/ehs/documentation/doc-management/doc-management.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-documentation-documentation-module~ehs-documentation-doc-management-doc-management-m~d4f7ef9a",
		"common",
		"ehs-documentation-doc-management-doc-management-module"
	],
	"@ehs/emergency/drill-action/drill-action.module": [
		"./src/app/ehs/emergency/drill-action/drill-action.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-emergency-drill-action-drill-actio~06abf6ec",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~7141eb31",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-drill-action-drill-action-module",
		"common",
		"ehs-emergency-drill-action-drill-action-module"
	],
	"@ehs/emergency/emergency-action/emergency-action.module": [
		"./src/app/ehs/emergency/emergency-action/emergency-action.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-action-emergency-action-module",
		"common",
		"ehs-emergency-emergency-action-emergency-action-module"
	],
	"@ehs/emergency/emergency-drill-assessment/emergency-drill-assessment.module": [
		"./src/app/ehs/emergency/emergency-drill-assessment/emergency-drill-assessment.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~7141eb31",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-drill-assessment-emergency-drill-~b5206536",
		"common",
		"ehs-emergency-emergency-drill-assessment-emergency-drill-assessment-module"
	],
	"@ehs/emergency/emergency-drill-plan/emergency-drill-plan.module": [
		"./src/app/ehs/emergency/emergency-drill-plan/emergency-drill-plan.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-drill-plan-emergency-drill-plan-m~bedba7d6",
		"common",
		"ehs-emergency-emergency-drill-plan-emergency-drill-plan-module"
	],
	"@ehs/emergency/emergency-drill-record/emergency-drill-record.module": [
		"./src/app/ehs/emergency/emergency-drill-record/emergency-drill-record.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-drill-record-emergency-drill-reco~39464914",
		"common",
		"ehs-emergency-emergency-drill-record-emergency-drill-record-module"
	],
	"@ehs/emergency/emergency-plan/emergency-plan.module": [
		"./src/app/ehs/emergency/emergency-plan/emergency-plan.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-plan-emergency-plan-module",
		"common",
		"ehs-emergency-emergency-plan-emergency-plan-module"
	],
	"@ehs/emergency/emergency-supplies/emergency-supplies.module": [
		"./src/app/ehs/emergency/emergency-supplies/emergency-supplies.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-supplies-emergency-supplies-modul~4bc38faf",
		"common",
		"ehs-emergency-emergency-supplies-emergency-supplies-module"
	],
	"@ehs/emergency/emergency-team/emergency-team.module": [
		"./src/app/ehs/emergency/emergency-team/emergency-team.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-team-emergency-team-module",
		"common",
		"ehs-emergency-emergency-team-emergency-team-module"
	],
	"@ehs/incident/abnormal-event-report/abnormal-event-report.module": [
		"./src/app/ehs/incident/abnormal-event-report/abnormal-event-report.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-emergency-drill-action-drill-actio~06abf6ec",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~fa2f04ac",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~0a007686",
		"default~app-ehs-incident-incident-module~ehs-incident-abnormal-event-report-abnormal-event-report-mo~32ea94c4",
		"common",
		"ehs-incident-abnormal-event-report-abnormal-event-report-module"
	],
	"@ehs/incident/hazard-report/hazard-report.module": [
		"./src/app/ehs/incident/hazard-report/hazard-report.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-incident-hazard-report-hazard-report-module"
	],
	"@ehs/incident/incident-diagnostic/incident-diagnostic.module": [
		"./src/app/ehs/incident/incident-diagnostic/incident-diagnostic.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~fa2f04ac",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~0a007686",
		"default~app-ehs-incident-incident-module~ehs-incident-incident-diagnostic-incident-diagnostic-module",
		"common",
		"ehs-incident-incident-diagnostic-incident-diagnostic-module"
	],
	"@ehs/incident/incident-inquiry/incident-inquiry.module": [
		"./src/app/ehs/incident/incident-inquiry/incident-inquiry.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-incident-incident-inquiry-incident-inquiry-module"
	],
	"@ehs/incident/incident-investigation/incident-investigation.module": [
		"./src/app/ehs/incident/incident-investigation/incident-investigation.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~fa2f04ac",
		"common",
		"ehs-incident-incident-investigation-incident-investigation-module"
	],
	"@ehs/incident/incident-report/incident-report.module": [
		"./src/app/ehs/incident/incident-report/incident-report.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~fa2f04ac",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~0a007686",
		"default~app-ehs-incident-incident-module~ehs-incident-incident-report-incident-report-module",
		"common",
		"ehs-incident-incident-report-incident-report-module"
	],
	"@ehs/incident/injury-record/injury-record.module": [
		"./src/app/ehs/incident/injury-record/injury-record.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-incident-incident-module~ehs-incident-injury-record-injury-record-module",
		"common",
		"ehs-incident-injury-record-injury-record-module"
	],
	"@ehs/incident/working-day/working-day.module": [
		"./src/app/ehs/incident/working-day/working-day.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-incident-working-day-working-day-module"
	],
	"@ehs/inspection/ad-hoc-inspection/ad-hoc-inspection.module": [
		"./src/app/ehs/inspection/ad-hoc-inspection/ad-hoc-inspection.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"common",
		"ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module"
	],
	"@ehs/inspection/corrective-action-record/corrective-action-record.module": [
		"./src/app/ehs/inspection/corrective-action-record/corrective-action-record.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-inspection-corrective-action-record-corrective-action-record-module"
	],
	"@ehs/inspection/corrective-action/corrective-action.module": [
		"./src/app/ehs/inspection/corrective-action/corrective-action.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-corrective-action-corrective-action-modu~f5e42bee",
		"common",
		"ehs-inspection-corrective-action-corrective-action-module"
	],
	"@ehs/inspection/gov-corrective-action-record/corrective-action-record.module": [
		"./src/app/ehs/inspection/gov-corrective-action-record/corrective-action-record.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-inspection-gov-corrective-action-record-corrective-action-record-module"
	],
	"@ehs/inspection/gov-inspection-reporting/gov-inspection-reporting.module": [
		"./src/app/ehs/inspection/gov-inspection-reporting/gov-inspection-reporting.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"common",
		"ehs-inspection-gov-inspection-reporting-gov-inspection-reporting-module"
	],
	"@ehs/inspection/gov-inspection/gov-inspection.module": [
		"./src/app/ehs/inspection/gov-inspection/gov-inspection.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-gov-inspection-gov-inspection-module",
		"common",
		"ehs-inspection-gov-inspection-gov-inspection-module"
	],
	"@ehs/inspection/gov-penalty/gov-penalty.module": [
		"./src/app/ehs/inspection/gov-penalty/gov-penalty.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"common",
		"ehs-inspection-gov-penalty-gov-penalty-module"
	],
	"@ehs/inspection/inspection-record/inspection-record.module": [
		"./src/app/ehs/inspection/inspection-record/inspection-record.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-inspection-inspection-record-inspection-record-module"
	],
	"@ehs/inspection/inspection-scheduling/inspection-scheduling.module": [
		"./src/app/ehs/inspection/inspection-scheduling/inspection-scheduling.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-inspection-scheduling-inspection-schedul~0f761666",
		"common",
		"ehs-inspection-inspection-scheduling-inspection-scheduling-module"
	],
	"@ehs/inspection/issue-record/issue-record.module": [
		"./src/app/ehs/inspection/issue-record/issue-record.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-issue-record-issue-record-module",
		"common",
		"ehs-inspection-issue-record-issue-record-module"
	],
	"@ehs/inspection/issue-reporting/issue-reporting.module": [
		"./src/app/ehs/inspection/issue-reporting/issue-reporting.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"common",
		"ehs-inspection-issue-reporting-issue-reporting-module"
	],
	"@ehs/inspection/non-scheduled-inspection/non-scheduled-inspection.module": [
		"./src/app/ehs/inspection/non-scheduled-inspection/non-scheduled-inspection.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-non-scheduled-inspection-non-scheduled-i~6f1056cf",
		"common",
		"ehs-inspection-non-scheduled-inspection-non-scheduled-inspection-module"
	],
	"@ehs/inspection/reported-issue/reported-issue.module": [
		"./src/app/ehs/inspection/reported-issue/reported-issue.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-reported-issue-reported-issue-module",
		"common",
		"ehs-inspection-reported-issue-reported-issue-module"
	],
	"@ehs/inspection/scheduled-inspection/scheduled-inspection.module": [
		"./src/app/ehs/inspection/scheduled-inspection/scheduled-inspection.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-scheduled-inspection-scheduled-inspectio~6711bed3",
		"common",
		"ehs-inspection-scheduled-inspection-scheduled-inspection-module"
	],
	"@ehs/notification/announcement/announcement.module": [
		"./src/app/ehs/notification/announcement/announcement.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-notification-announcement-announcement-module~ehs-risk-three-cards-management-three-card~11166a2c",
		"default~app-ehs-notification-notification-module~ehs-notification-announcement-announcement-module",
		"common",
		"ehs-notification-announcement-announcement-module"
	],
	"@ehs/notification/message-group/message-group.module": [
		"./src/app/ehs/notification/message-group/message-group.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-notification-message-group-message-group-module"
	],
	"@ehs/regulation/activity/activity.module": [
		"./src/app/ehs/regulation/activity/activity.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-safety-observation-safety-observation-module~ehs-regulation-activity-activity-module~b6a37bdc",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module~ehs-regulati~f8440154",
		"common",
		"ehs-regulation-activity-activity-module"
	],
	"@ehs/regulation/database/database.module": [
		"./src/app/ehs/regulation/database/database.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-safety-observation-safety-observation-module~ehs-regulation-activity-activity-module~b6a37bdc",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module~ehs-regulati~f8440154",
		"default~ehs-regulation-database-database-module~ehs-regulation-database-draft-draft-module",
		"common",
		"ehs-regulation-database-database-module"
	],
	"@ehs/regulation/database/draft/draft.module": [
		"./src/app/ehs/regulation/database/draft/draft.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-regulation-database-database-module~ehs-regulation-database-draft-draft-module",
		"common",
		"ehs-regulation-database-draft-draft-module"
	],
	"@ehs/regulation/improvement/improvement.module": [
		"./src/app/ehs/regulation/improvement/improvement.module.ts",
		"common",
		"ehs-regulation-improvement-improvement-module"
	],
	"@ehs/regulation/improvement/list/list.module": [
		"./src/app/ehs/regulation/improvement/list/list.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-safety-observation-safety-observation-module~ehs-regulation-activity-activity-module~b6a37bdc",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module~ehs-regulati~f8440154",
		"common",
		"ehs-regulation-improvement-list-list-module"
	],
	"@ehs/regulation/task/cooperation/cooperation.module": [
		"./src/app/ehs/regulation/task/cooperation/cooperation.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-safety-observation-safety-observation-module~ehs-regulation-activity-activity-module~b6a37bdc",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module~ehs-regulati~f8440154",
		"common",
		"ehs-regulation-task-cooperation-cooperation-module"
	],
	"@ehs/regulation/task/list/list.module": [
		"./src/app/ehs/regulation/task/list/list.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-safety-observation-safety-observation-module~ehs-regulation-activity-activity-module~b6a37bdc",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module~ehs-regulati~f8440154",
		"common",
		"ehs-regulation-task-list-list-module"
	],
	"@ehs/regulation/task/task.module": [
		"./src/app/ehs/regulation/task/task.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-regulation-task-task-module"
	],
	"@ehs/risk/conduct-job-record/conduct-job-record.module": [
		"./src/app/ehs/risk/conduct-job-record/conduct-job-record.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-risk-conduct-job-record-conduct-job-record-module"
	],
	"@ehs/risk/conduct/conduct.module": [
		"./src/app/ehs/risk/conduct/conduct.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-emergency-drill-action-drill-actio~06abf6ec",
		"default~app-ehs-risk-risk-module~ehs-corrective-action-detail-corrective-action-module~ehs-risk-cond~90c16981",
		"default~app-ehs-risk-risk-module~ehs-risk-conduct-conduct-module~ehs-risk-matrix-matrix-module",
		"default~ehs-risk-conduct-conduct-module~ehs-risk-job-task-job-task-module~ehs-risk-planning-planning~4f74667a",
		"default~ehs-risk-conduct-conduct-module~ehs-risk-job-task-job-task-module",
		"common",
		"ehs-risk-conduct-conduct-module"
	],
	"@ehs/risk/job-task/job-task.module": [
		"./src/app/ehs/risk/job-task/job-task.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-risk-risk-module~ehs-risk-job-task-job-task-module~ehs-risk-matrix-matrix-module",
		"default~ehs-risk-conduct-conduct-module~ehs-risk-job-task-job-task-module~ehs-risk-planning-planning~4f74667a",
		"default~ehs-risk-conduct-conduct-module~ehs-risk-job-task-job-task-module",
		"common",
		"ehs-risk-job-task-job-task-module"
	],
	"@ehs/risk/matrix/matrix.module": [
		"./src/app/ehs/risk/matrix/matrix.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-risk-risk-module~ehs-corrective-action-detail-corrective-action-module~ehs-risk-cond~90c16981",
		"default~app-ehs-risk-risk-module~ehs-risk-job-task-job-task-module~ehs-risk-matrix-matrix-module",
		"default~app-ehs-risk-risk-module~ehs-risk-conduct-conduct-module~ehs-risk-matrix-matrix-module",
		"default~app-ehs-risk-risk-module~ehs-risk-matrix-matrix-module~ehs-risk-planning-planning-module",
		"default~app-ehs-risk-risk-module~ehs-risk-matrix-matrix-module",
		"common",
		"ehs-risk-matrix-matrix-module"
	],
	"@ehs/risk/planning/planning.module": [
		"./src/app/ehs/risk/planning/planning.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-risk-risk-module~ehs-risk-matrix-matrix-module~ehs-risk-planning-planning-module",
		"default~ehs-risk-conduct-conduct-module~ehs-risk-job-task-job-task-module~ehs-risk-planning-planning~4f74667a",
		"common",
		"ehs-risk-planning-planning-module"
	],
	"@ehs/risk/risk-factors/risk-factors.module": [
		"./src/app/ehs/risk/risk-factors/risk-factors.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-risk-risk-factors-risk-factors-module"
	],
	"@ehs/risk/security-risk/security-risk.module": [
		"./src/app/ehs/risk/security-risk/security-risk.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-risk-security-risk-security-risk-module"
	],
	"@ehs/risk/three-cards-management/three-cards.module": [
		"./src/app/ehs/risk/three-cards-management/three-cards.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-dashboard-emergency-emergency-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-mod~24725816",
		"default~ehs-notification-announcement-announcement-module~ehs-risk-three-cards-management-three-card~11166a2c",
		"common",
		"ehs-risk-three-cards-management-three-cards-module"
	],
	"@ehs/system-setting/employee/employee.module": [
		"./src/app/ehs/system-setting/employee/employee.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-employee-employee-module",
		"common",
		"ehs-system-setting-employee-employee-module"
	],
	"@ehs/system-setting/form-management/form-management.module": [
		"./src/app/ehs/system-setting/form-management/form-management.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-form-management-form-managem~62dc5505",
		"common",
		"ehs-system-setting-form-management-form-management-module"
	],
	"@ehs/system-setting/message-group/message-group.module": [
		"./src/app/ehs/system-setting/message-group/message-group.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-system-setting-message-group-message-group-module"
	],
	"@ehs/system-setting/organization/organization.module": [
		"./src/app/ehs/system-setting/organization/organization.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-system-setting-organization-organization-module"
	],
	"@ehs/system-setting/physical-attribute/physical-attribute.module": [
		"./src/app/ehs/system-setting/physical-attribute/physical-attribute.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-physical-attribute-physical-~f0202f54",
		"common",
		"ehs-system-setting-physical-attribute-physical-attribute-module"
	],
	"@ehs/system-setting/physical-structure/facility/facility.module": [
		"./src/app/ehs/system-setting/physical-structure/facility/facility.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-physical-structure-facility-~3ec66631",
		"common",
		"ehs-system-setting-physical-structure-facility-facility-module"
	],
	"@ehs/system-setting/physical-structure/physical-structure.module": [
		"./src/app/ehs/system-setting/physical-structure/physical-structure.module.ts",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-physical-structure-facility-~3ec66631",
		"common",
		"ehs-system-setting-physical-structure-physical-structure-module"
	],
	"@ehs/system-setting/question-bank/question-bank.module": [
		"./src/app/ehs/system-setting/question-bank/question-bank.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-question-bank-question-bank-~d38b3fed",
		"common",
		"ehs-system-setting-question-bank-question-bank-module"
	],
	"@ehs/system-setting/role-management/role-management.module": [
		"./src/app/ehs/system-setting/role-management/role-management.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-system-setting-role-management-role-management-module"
	],
	"@ehs/system-setting/space-management/space-management.module": [
		"./src/app/ehs/system-setting/space-management/space-management.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-system-setting-space-management-space-management-module"
	],
	"@ehs/system-setting/system-code/system-code.module": [
		"./src/app/ehs/system-setting/system-code/system-code.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-system-setting-system-code-system-code-module"
	],
	"@ehs/training-new/calendar/calendar.module": [
		"./src/app/ehs/training-new/calendar/calendar.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-training-calendar-calendar-module~ehs-training-calendar-dept-calendar-dept-module~ehs-tr~ea82a156",
		"common",
		"ehs-training-new-calendar-calendar-module"
	],
	"@ehs/training-new/course-scheduling/course-scheduling.module": [
		"./src/app/ehs/training-new/course-scheduling/course-scheduling.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-ehs-training-new-training-module~ehs-training-new-course-scheduling-course-scheduling-mo~2aef0369",
		"common",
		"ehs-training-new-course-scheduling-course-scheduling-module"
	],
	"@ehs/training/calendar-dept/calendar-dept.module": [
		"./src/app/ehs/training/calendar-dept/calendar-dept.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-training-calendar-calendar-module~ehs-training-calendar-dept-calendar-dept-module~ehs-tr~ea82a156",
		"common",
		"ehs-training-calendar-dept-calendar-dept-module"
	],
	"@ehs/training/calendar/calendar.module": [
		"./src/app/ehs/training/calendar/calendar.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-training-calendar-calendar-module~ehs-training-calendar-dept-calendar-dept-module~ehs-tr~ea82a156",
		"common",
		"ehs-training-calendar-calendar-module"
	],
	"@ehs/training/certificate-category/certificate-category.module": [
		"./src/app/ehs/training/certificate-category/certificate-category.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~953f08d8",
		"common"
	],
	"@ehs/training/certificate/certificate.module": [
		"./src/app/ehs/training/certificate/certificate.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~953f08d8",
		"common",
		"ehs-training-certificate-certificate-module"
	],
	"@ehs/training/class/class.module": [
		"./src/app/ehs/training/class/class.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-dashboard-training-training-dashboard-module~ehs-training-class-class-module",
		"common",
		"ehs-training-class-class-module"
	],
	"@ehs/training/exemption/exemption.module": [
		"./src/app/ehs/training/exemption/exemption.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-training-exemption-exemption-module"
	],
	"@ehs/training/instructor/instructor.module": [
		"./src/app/ehs/training/instructor/instructor.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-training-instructor-instructor-module"
	],
	"@ehs/training/lesson/lesson.module": [
		"./src/app/ehs/training/lesson/lesson.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"default~ehs-notification-announcement-announcement-module~ehs-risk-three-cards-management-three-card~11166a2c",
		"default~ehs-training-lesson-lesson-module~ehs-training-train-record-train-record-module",
		"common",
		"ehs-training-lesson-lesson-module"
	],
	"@ehs/training/my-course/my-course.module": [
		"./src/app/ehs/training/my-course/my-course.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"common",
		"ehs-training-my-course-my-course-module"
	],
	"@ehs/training/question-set/question-set.module": [
		"./src/app/ehs/training/question-set/question-set.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"common",
		"ehs-training-question-set-question-set-module"
	],
	"@ehs/training/quiz/quiz.module": [
		"./src/app/ehs/training/quiz/quiz.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"common",
		"ehs-training-quiz-quiz-module"
	],
	"@ehs/training/record/record.module": [
		"./src/app/ehs/training/record/record.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"ehs-training-record-record-module"
	],
	"@ehs/training/sign-table/sign-table.module": [
		"./src/app/ehs/training/sign-table/sign-table.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"default~ehs-training-sign-table-sign-table-module~ehs-training-train-record-train-record-module",
		"common",
		"ehs-training-sign-table-sign-table-module"
	],
	"@ehs/training/train-record/train-record.module": [
		"./src/app/ehs/training/train-record/train-record.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~ehs-emergency-drill-action-drill-action-module~ehs-emergency-emergency-drill-assessment-emer~fddf283f",
		"default~ehs-training-lesson-lesson-module~ehs-training-train-record-train-record-module",
		"default~ehs-training-sign-table-sign-table-module~ehs-training-train-record-train-record-module",
		"common",
		"ehs-training-train-record-train-record-module"
	],
	"app/auth/auth.module": [
		"./src/app/auth/auth.module.ts"
	],
	"app/ehs/dashboard/dashboard.module": [
		"./src/app/ehs/dashboard/dashboard.module.ts",
		"default~app-ehs-dashboard-dashboard-module~ehs-dashboard-training-training-dashboard-module",
		"default~app-ehs-dashboard-dashboard-module~ehs-dashboard-hazard-hazard-dashboard-module",
		"default~app-ehs-dashboard-dashboard-module~ehs-dashboard-emergency-emergency-dashboard-module",
		"default~app-ehs-dashboard-dashboard-module~ehs-dashboard-risk-assessment-risk-assessment-dashboard-m~7757e66a",
		"default~app-ehs-dashboard-dashboard-module~ehs-dashboard-overview-overview-dashboard-module",
		"common",
		"app-ehs-dashboard-dashboard-module"
	],
	"app/ehs/documentation/documentation.module": [
		"./src/app/ehs/documentation/documentation.module.ts",
		"default~app-ehs-documentation-documentation-module~ehs-documentation-doc-management-doc-management-m~d4f7ef9a",
		"common",
		"app-ehs-documentation-documentation-module"
	],
	"app/ehs/ehs.module": [
		"./src/app/ehs/ehs.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"common",
		"app-ehs-ehs-module"
	],
	"app/ehs/emergency/emergency.module": [
		"./src/app/ehs/emergency/emergency.module.ts",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-drill-plan-emergency-drill-plan-m~bedba7d6",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-action-emergency-action-module",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-supplies-emergency-supplies-modul~4bc38faf",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-drill-record-emergency-drill-reco~39464914",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-drill-action-drill-action-module",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-drill-assessment-emergency-drill-~b5206536",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-plan-emergency-plan-module",
		"default~app-ehs-emergency-emergency-module~ehs-emergency-emergency-team-emergency-team-module",
		"common",
		"app-ehs-emergency-emergency-module"
	],
	"app/ehs/incident/incident.module": [
		"./src/app/ehs/incident/incident.module.ts",
		"default~app-ehs-incident-incident-module~ehs-incident-abnormal-event-report-abnormal-event-report-mo~32ea94c4",
		"default~app-ehs-incident-incident-module~ehs-incident-incident-diagnostic-incident-diagnostic-module",
		"default~app-ehs-incident-incident-module~ehs-incident-incident-report-incident-report-module",
		"default~app-ehs-incident-incident-module~ehs-incident-injury-record-injury-record-module",
		"common",
		"app-ehs-incident-incident-module"
	],
	"app/ehs/inspection/inspection.module": [
		"./src/app/ehs/inspection/inspection.module.ts",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-scheduled-inspection-scheduled-inspectio~6711bed3",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-inspection-scheduling-inspection-schedul~0f761666",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-non-scheduled-inspection-non-scheduled-i~6f1056cf",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-corrective-action-corrective-action-modu~f5e42bee",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-reported-issue-reported-issue-module",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-issue-record-issue-record-module",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-gov-inspection-gov-inspection-module",
		"common",
		"app-ehs-inspection-inspection-module"
	],
	"app/ehs/message-center/message-center.module": [
		"./src/app/ehs/message-center/message-center.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"app-ehs-message-center-message-center-module"
	],
	"app/ehs/notification/notification.module": [
		"./src/app/ehs/notification/notification.module.ts",
		"default~app-ehs-notification-notification-module~ehs-notification-announcement-announcement-module",
		"common",
		"app-ehs-notification-notification-module"
	],
	"app/ehs/regulation/regulation.module": [
		"./src/app/ehs/regulation/regulation.module.ts",
		"app-ehs-regulation-regulation-module"
	],
	"app/ehs/risk/risk.module": [
		"./src/app/ehs/risk/risk.module.ts",
		"default~app-ehs-risk-risk-module~ehs-corrective-action-detail-corrective-action-module~ehs-risk-cond~90c16981",
		"default~app-ehs-risk-risk-module~ehs-risk-job-task-job-task-module~ehs-risk-matrix-matrix-module",
		"default~app-ehs-risk-risk-module~ehs-risk-conduct-conduct-module~ehs-risk-matrix-matrix-module",
		"default~app-ehs-risk-risk-module~ehs-risk-matrix-matrix-module~ehs-risk-planning-planning-module",
		"default~app-ehs-risk-risk-module~ehs-risk-matrix-matrix-module",
		"common",
		"app-ehs-risk-risk-module"
	],
	"app/ehs/safety-observation/safety-observation.module": [
		"./src/app/ehs/safety-observation/safety-observation.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-safety-observation-safety-observation-module~ehs-regulation-activity-activity-module~b6a37bdc",
		"common",
		"app-ehs-safety-observation-safety-observation-module"
	],
	"app/ehs/system-announcement/system-announcement.module": [
		"./src/app/ehs/system-announcement/system-announcement.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"app-ehs-system-announcement-system-announcement-module"
	],
	"app/ehs/system-setting/system-setting.module": [
		"./src/app/ehs/system-setting/system-setting.module.ts",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-physical-structure-facility-~3ec66631",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-employee-employee-module",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-form-management-form-managem~62dc5505",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-physical-attribute-physical-~f0202f54",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-question-bank-question-bank-~d38b3fed",
		"common",
		"app-ehs-system-setting-system-setting-module"
	],
	"app/ehs/task-center-new/task-center.module": [
		"./src/app/ehs/task-center-new/task-center.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"app-ehs-task-center-new-task-center-module"
	],
	"app/ehs/task-center/task-center.module": [
		"./src/app/ehs/task-center/task-center.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"app-ehs-task-center-task-center-module"
	],
	"app/ehs/training-new/training.module": [
		"./src/app/ehs/training-new/training.module.ts",
		"default~app-ehs-training-new-training-module~ehs-training-new-course-scheduling-course-scheduling-mo~2aef0369",
		"common",
		"app-ehs-training-new-training-module"
	],
	"app/ehs/training/training.module": [
		"./src/app/ehs/training/training.module.ts",
		"app-ehs-training-training-module"
	],
	"app/quantum-theme/views/themes/quantum/theme.module": [
		"./src/app/quantum-theme/views/themes/quantum/theme.module.ts",
		"app-quantum-theme-views-themes-quantum-theme-module"
	],
	"app/screen-dashboard/screen-dashboard.module": [
		"./src/app/screen-dashboard/screen-dashboard.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-dashboard-overview-overview-dashboard-modul~cac639de",
		"common",
		"app-screen-dashboard-screen-dashboard-module"
	],
	"app/share-inspection/share-inspection.module": [
		"./src/app/share-inspection/share-inspection.module.ts",
		"default~app-ehs-ehs-module~app-ehs-message-center-message-center-module~app-ehs-safety-observation-s~c2f0cdd2",
		"default~app-ehs-message-center-message-center-module~app-ehs-safety-observation-safety-observation-m~62d138aa",
		"default~app-ehs-message-center-message-center-module~app-ehs-system-announcement-system-announcement~bc34ef74",
		"common",
		"app-share-inspection-share-inspection-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;